
export default class ImageStack {
    static initAll() {
        const imageStackWrappers = document.querySelectorAll('.image-stack');
        if (imageStackWrappers.length === 0) return;

        imageStackWrappers.forEach((imageStackWrapper) => ImageStack.init(imageStackWrapper));
    }

    static init(imageStackWrapper) {
        return new ImageStack(imageStackWrapper);
    }

    constructor(imageStackWrapper) {
        this.imageStackWrapper = imageStackWrapper;
        this.imageStack = Array.from(imageStackWrapper.querySelectorAll('.stack-image'));
        this.prevArrowButton = imageStackWrapper.querySelector('.image-stack-arrow-button.prev');
        this.nextArrowButton = imageStackWrapper.querySelector('.image-stack-arrow-button.next');
        this.currentImageIndex = 0;

        this._updateImageHeights();
        this._initButtons();

        window.addEventListener('resize', () => this._updateImageHeights());
    }

    _initButtons() {
        this.prevArrowButton.addEventListener('click', (event) => {
            const image = this.imageStack[--this.currentImageIndex];
            this._setZIndex(image, this.imageStack.length - this.currentImageIndex);
            setTimeout(() => {
                image.classList.add('on-main');
            }, 50);

            this._updateButtons();
        });

        this.nextArrowButton.addEventListener('click', (event) => {
            const image = this.imageStack[this.currentImageIndex];
            image.classList.remove('on-main');
            setTimeout(this._setZIndex, 150, image, -this.imageStack.length + this.currentImageIndex);
            ++this.currentImageIndex;

            this._updateButtons();
        });

        this._updateButtons();
    }

    _updateImageHeights() {
        this.imageStack.forEach((image) => {
            image.style.height = image.querySelector('img').clientHeight + 'px';
        });

        this.imageStackWrapper.style.height = Math.max(...this.imageStack.map(i => i.clientHeight)) + 'px';
    }
    
    _updateButtons() {
        if (this.prevArrowButton !== null && this.currentImageIndex > 0) this.prevArrowButton.style.display = 'flex';
        else this.prevArrowButton.style.display = 'none';
    
        if (this.nextArrowButton !== null && this.currentImageIndex < this.imageStack.length - 1) this.nextArrowButton.style.display = 'flex';
        else this.nextArrowButton.style.display = 'none';
    }

    _setZIndex(element, index) {
        element.style.zIndex = index;
    }
}
